export const GOOGLE_BUSINESS_REAUTH_ERROR_CODES = [
  'GOOGLE_BUSINESS_API_REAUTH',
  'GOOGLE_BUSINESS_CREDENTIALS_MISSING',
  'GOOGLE_BUSINESS_FETCH_FAILED',
  'GOOGLE_BUSINESS_DETAILS_ERROR',
] as const

export function isGoogleBusinessReauthError(code: string | undefined): boolean {
  return !!code && (GOOGLE_BUSINESS_REAUTH_ERROR_CODES as readonly string[]).includes(code)
}
